export default __webpack_public_path__ + "static/media/cif-cv.a13fcc05.svg";